import React from "react";
import PropTypes from "prop-types";
import { toastr } from "react-redux-toastr";

// State management
import { connect } from "react-redux";
import { requestResetPassword } from "../../redux/actions/userActions";

import { Button, Card, CardBody, Form, FormGroup, Label, Input } from "reactstrap";

const RequestPasswordReset = ({ history, requestResetPassword }) => {
  const [userEmail, setUserEmail] = React.useState("");

  function submitPassword(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (!userEmail) {
      return toastr.error("Oops", "Please provide your email address");
    }

    if (!/^.+@.+$/.test(userEmail)) {
      return toastr.error("Oops", "Please enter a valid email address");
    }

    requestResetPassword(userEmail).then((success) => {
      if (success) {
        toastr.success(
          "We have received your request",
          "You should receive an email with instructions shortly"
        );
        history.push("/");
      }
    });
  }

  return (
    <React.Fragment>
      <div className="text-center mt-4">
        <h1 className="h2">Reset password</h1>

        <p className="lead">
          Enter your email address below and we'll email you to start the password recovery process.
        </p>
      </div>

      <Card>
        <CardBody>
          <div className="m-sm-4">
            <Form onSubmit={submitPassword}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  bsSize="lg"
                  type="email"
                  name="email"
                  value={userEmail}
                  onChange={({ target }) => setUserEmail(target.value)}
                  required={true}
                  placeholder="Enter your email"
                />
              </FormGroup>

              <div className="text-center mt-3">
                <Button color="primary" size="lg">
                  Reset password
                </Button>
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

RequestPasswordReset.propTypes = {
  requestResetPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { requestResetPassword })(RequestPasswordReset);
